let passwordToggle = (e = null) => {
	if (!e) {
		return false;
	}
	let target = e.currentTarget;
	let parent = target.parentNode;
	let input = parent.querySelector('input');
	if (!input) {
		return false;
	}
	if ('password' === input.type) {
		input.type = 'text';
		target.innerHTML = oda_localize.button_hide
			? oda_localize.button_hide
			: 'Hide';
	} else {
		input.type = 'password';
		target.innerHTML = oda_localize.button_show
			? oda_localize.button_show
			: 'Show';
	}
};
export default passwordToggle;
